import { observable, action, runInAction, computed, toJS } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { paramGroups } from '@services/api'

export class paramGroupsStore extends StoreExt {
    @observable list = []
    @observable filteredList = []
    @observable filterText = ''

    @action
    getList = async () => {
        const { data: list } = await paramGroups.getList()
        runInAction(() => {
            this.list = list
            this.filterList(this.filterText)
        })
    }

    @action
    filterList = filterText => {
        this.filterText = filterText
        this.filteredList = this.list.filter(item => item.name.includes(filterText) || item.id === filterText)
    }

    @action
    resetParamGroups = () => {
        this.list = []
        this.filteredList = []
        this.filterText = ''
    }
}

export default remotedev(new paramGroupsStore())
